var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/arrow/small-right",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 2,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42195955,12.5658393 C9.53532408,12.6769348 9.68720036,12.7399778 9.84591498,12.7418208 L10.149883,12.7418208 C10.3089426,12.7416808 10.4614364,12.6783814 10.5738384,12.5658393 L13.8774911,9.25418747 C13.9532082,9.17908872 13.995798,9.07686113 13.995798,8.97021732 C13.995798,8.86357352 13.9532082,8.76134592 13.8774911,8.68624718 L13.31755,8.11830689 C13.2424512,8.04258979 13.1402236,8 13.0335798,8 C12.926936,8 12.8247084,8.04258979 12.7496097,8.11830689 L9.997899,10.8780167 L7.24618831,8.12630605 C7.17246519,8.05106271 7.07155842,8.00866127 6.96621774,8.00866127 C6.86087706,8.00866127 6.7599703,8.05106271 6.68624718,8.12630605 L6.11830689,8.69424634 C6.04258979,8.76934508 6,8.87157268 6,8.97821648 C6,9.08486028 6.04258979,9.18708788 6.11830689,9.26218663 L9.42195955,12.5658393 Z",
    id: "Path",
    fill: "#192233",
    transform: "translate(9.997899, 10.370910) rotate(90.000000) translate(-9.997899, -10.370910) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.a7818499.svg";
export { ForwardRef as ReactComponent };